import { fixFontSize, tryMigrateFontSize } from '@gr/absolute-font-size-fix';

fixFontSize();
document.addEventListener('DOMContentLoaded', () => {
  tryMigrateFontSize();
});
